export const STATUS_NAME_MAX_LENGTH = 30;

// Temporary Status Id, will be overridden in the backend
export const TEMPORARY_STATUS_ID = 42;
